// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-63b2b606] .ant-tabs-bar {\n  border-bottom: none;\n}\n[data-v-63b2b606] .ant-tabs-tab {\n  border-radius: 4px !important;\n  margin-right: 15px !important;\n}\n[data-v-63b2b606] .ant-tabs-tab-active {\n  border-bottom: 1px solid #e8e8e8 !important;\n  background: #1890ff !important;\n  color: #fff !important;\n}", ""]);
// Exports
module.exports = exports;
